import type { BasicSelectOption } from 'src/components/shared/form/BasicSelect'
import { ContractorType, PaymentPeriodType, PayoutDestination, PayoutType } from './enums'

/**
 * Options render the raw wire value the way the Retool tab does. An admin cross-referencing a
 * Retool export, a support ticket or a database row is matching on `per_payment`, not on a
 * prettified "Per payment".
 */
export const PAYOUT_TYPE_OPTIONS: BasicSelectOption[] = [
  { label: PayoutType.Financed, value: PayoutType.Financed },
  { label: PayoutType.NonFinanced, value: PayoutType.NonFinanced },
]

export const PAYMENT_PERIOD_OPTIONS: BasicSelectOption[] = [
  { label: PaymentPeriodType.PerPayment, value: PaymentPeriodType.PerPayment },
  { label: PaymentPeriodType.PerDay, value: PaymentPeriodType.PerDay },
  { label: PaymentPeriodType.PerWeek, value: PaymentPeriodType.PerWeek },
  { label: PaymentPeriodType.PerMonth, value: PaymentPeriodType.PerMonth },
  { label: PaymentPeriodType.PerYear, value: PaymentPeriodType.PerYear },
]

export const PAYOUT_DESTINATION_OPTIONS: BasicSelectOption[] = [
  { label: PayoutDestination.BankAccount, value: PayoutDestination.BankAccount },
  { label: PayoutDestination.Card, value: PayoutDestination.Card },
]

export const CONTRACTOR_TYPE_OPTIONS: BasicSelectOption[] = [
  { label: ContractorType.McLiteMaster, value: ContractorType.McLiteMaster },
  { label: ContractorType.McLiteSubcontractor, value: ContractorType.McLiteSubcontractor },
  { label: ContractorType.Direct, value: ContractorType.Direct },
]

/**
 * The rate columns are `@Column('decimal', { precision: 4, scale: 2 })`, so 99.99 is the real
 * ceiling. The DTO carries no `@Max`, and exceeding it fails in the Postgres driver as an
 * opaque 500 rather than a validation message.
 */
export const MAX_RATE = 99.99

/**
 * Zero to two integer digits, optionally a decimal point and one or two digits. Enforces the
 * `decimal(4,2)` bound and the two-decimal precision in a single rule, without the
 * floating-point rounding a `value * 100` precision check would introduce.
 */
export const RATE_PATTERN = /^\d{1,2}(\.\d{1,2})?$/

/** Cents are an integer column. No decimal point, no sign. */
export const CENTS_PATTERN = /^\d+$/
